import {
  Component,
  EventEmitter,
  Input,
  Output,
  ChangeDetectionStrategy,
} from "@angular/core";
import { IVideoSource } from "../video-viewer/video-viewer.component";

@Component({
    selector: "ts-media-source-selection",
    templateUrl: "./media-source-selection.component.html",
    styleUrls: ["./media-source-selection.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class MediaSourceSelectionComponent {
  @Input() sources: IVideoSource[] = [];
  @Input() selectedIndex = 0;

  @Output() sourceSelected = new EventEmitter<number>();
  @Output() closePanel = new EventEmitter<void>();

  select(index: number) {
    this.sourceSelected.emit(index);
    this.closePanel.emit();
  }
}
